/* mm-bulten.js — bülten formu: e-posta biçimi + gizlilik onayı olmadan gönderilmez; düğme ikisi de tamamken etkin görünür. */
(() => {
  const EPOSTA = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  function kur(kok) {
    const form = kok.querySelector('form');
    if (!form || form.dataset.mmKurulu) return;
    const inp = form.querySelector('input[type="email"]');
    const onay = form.querySelector('[data-mm-onay]');
    const dugme = form.querySelector('[data-mm-gonder]');
    if (!inp || !onay || !dugme) return;
    form.dataset.mmKurulu = '1';
    const alan = form.querySelector('[data-mm-alan]');
    const hata = form.querySelector('[data-mm-hata]');
    const onayHata = form.querySelector('[data-mm-onay-hata]');
    const gecerli = () => EPOSTA.test(inp.value.trim());
    const guncelle = () => dugme.setAttribute('aria-disabled', gecerli() && onay.checked ? 'false' : 'true');
    const epostaHata = (v) => {
      alan.classList.toggle('is-error', v);
      if (v) { inp.setAttribute('aria-invalid', 'true'); hata.textContent = kok.dataset.hataEposta || ''; }
      else { inp.removeAttribute('aria-invalid'); hata.textContent = ''; }
    };
    inp.addEventListener('input', () => { if (alan.classList.contains('is-error') && gecerli()) epostaHata(false); guncelle(); });
    onay.addEventListener('change', () => { if (onay.checked) onayHata.textContent = ''; guncelle(); });
    form.addEventListener('submit', (e) => {
      const e1 = !gecerli(), e2 = !onay.checked;
      epostaHata(e1);
      onayHata.textContent = e2 ? (kok.dataset.hataOnay || '') : '';
      if (e1 || e2) { e.preventDefault(); (e1 ? inp : onay).focus(); return; }
      dugme.setAttribute('aria-busy', 'true');
    });
    guncelle();
  }
  const hepsi = () => document.querySelectorAll('[data-mm="bulten"]').forEach(kur);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hepsi); else hepsi();
  document.addEventListener('shopify:section:load', hepsi);
})();
